export default __webpack_public_path__ + "static/media/gl_7.7415b268.mp3";